module.exports = "<div class=\"overlay holder\"\n(click)=\"close()\"\n[ngClass]=\"{'active': active}\">\n  <div class=\"aligner\">\n    <div class=\"inner\">\n      <div class=\"title\">\n        <ng-content select=\"overlay-title\"></ng-content>\n      </div>\n      <div class=\"content\">\n        <ng-content select=\"overlay-content\"></ng-content>\n      </div>\n      <div class=\"actions\">\n        <ng-content select=\"overlay-actions\"></ng-content>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/overlay/overlay.component.html
// module id = ./src/app/components/shared/overlay/overlay.component.html
// module chunks = main